/* ============================================================
   SURPLUS SPORTSMAN — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Utility ---- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  /* ============================================================
     MOBILE NAV
  ============================================================ */
  const hamburger = $('#hamburger-btn');
  const mobileNav = $('#mobile-nav');
  const mobileBackdrop = $('.mobile-nav__backdrop', mobileNav || document);
  const mobileClose = $('#mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileNav.setAttribute('aria-hidden', 'false');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileNav.setAttribute('aria-hidden', 'true');
  }

  on(hamburger, 'click', openMobileNav);
  on(mobileBackdrop, 'click', closeMobileNav);
  on(mobileClose, 'click', closeMobileNav);

  /* ============================================================
     SEARCH OVERLAY
  ============================================================ */
  const searchBtns = $$('[data-search-toggle]');
  const searchOverlay = $('#search-overlay');
  const searchClose = $('#search-close');
  const searchBackdrop = $('.search-overlay__backdrop', searchOverlay || document);

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const input = $('.search-overlay__input', searchOverlay);
      if (input) input.focus();
    }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchBtns.forEach(btn => on(btn, 'click', openSearch));
  on(searchClose, 'click', closeSearch);
  on(searchBackdrop, 'click', closeSearch);

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeCartDrawer();
      closeMobileNav();
    }
  });

  /* ============================================================
     CART DRAWER
  ============================================================ */
  const cartDrawer = $('#cart-drawer');
  const cartOverlay = $('.cart-drawer__overlay', cartDrawer || document);
  const cartClose = $('.cart-drawer__close', cartDrawer || document);
  const cartCountEls = $$('.cart-count');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  on(cartOverlay, 'click', closeCartDrawer);
  on(cartClose, 'click', closeCartDrawer);

  $$('[data-cart-toggle]').forEach(btn => on(btn, 'click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));

  /* ---- Fetch & render cart ---- */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(console.error);
  }

  function updateCartCount(count) {
    cartCountEls.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    const itemsEl = $('#cart-drawer-items');
    const subtotalEl = $('#cart-drawer-subtotal');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    const html = cart.items.map(item => `
      <div class="cart-drawer-item" data-key="${item.key}">
        <div class="cart-drawer-item__inner">
          <a href="${item.url}">
            <img class="cart-drawer-item__img" src="${item.image}" alt="${item.title}" width="70" height="70">
          </a>
          <div class="cart-drawer-item__info">
            <a href="${item.url}" class="cart-drawer-item__title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>` : ''}
            <div class="cart-drawer-item__footer">
              <div class="cart-drawer-item__qty">
                <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
                <span>${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
              </div>
              <span class="cart-drawer-item__price">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      </div>
    `).join('');

    itemsEl.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Qty buttons
    $$('[data-action]', itemsEl).forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.dataset.key;
        const current = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        updateCartItem(key, newQty);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(console.error);
  }

  /* ---- Add to Cart ---- */
  on(document, 'click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
    const qty = parseInt(btn.closest('form')?.querySelector('[name="quantity"]')?.value || 1);
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        openCartDrawer();
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = btn.dataset.defaultText || 'Add to Cart';
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'Error — Try Again';
      });
  });

  /* ============================================================
     PRODUCT GALLERY (Product Page)
  ============================================================ */
  const thumbs = $$('.product-gallery__thumb');
  const mainImg = $('.product-gallery__main img');

  thumbs.forEach(thumb => {
    on(thumb, 'click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const src = thumb.querySelector('img')?.src;
        if (src) mainImg.src = src.replace('_80x80', '_800x800');
      }
    });
  });

  /* ============================================================
     PRODUCT TABS
  ============================================================ */
  const tabBtns = $$('.tab-btn');
  const tabPanels = $$('.tab-panel');

  tabBtns.forEach(btn => {
    on(btn, 'click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = $(`#tab-${target}`);
      if (panel) panel.classList.add('active');
    });
  });

  /* ============================================================
     VARIANT SELECTOR
  ============================================================ */
  const variantBtns = $$('.variant-btn');
  const variantIdInput = $('[name="id"]');

  variantBtns.forEach(btn => {
    on(btn, 'click', () => {
      const group = btn.closest('[data-option-name]');
      if (group) {
        $$('.variant-btn', group).forEach(b => b.classList.remove('active'));
      }
      btn.classList.add('active');
      updateVariant();
    });
  });

  function updateVariant() {
    // Basic variant matching — works for simple products
    const selectedOptions = $$('[data-option-name]').map(group => {
      return $('.variant-btn.active', group)?.dataset.value || '';
    });
    // Shopify variants are matched via productJSON if available
    const productJson = window.productData;
    if (!productJson || !variantIdInput) return;

    const match = productJson.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (match) {
      variantIdInput.value = match.id;
      // Update price
      const priceEl = $('.product-info__price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      // Update availability
      const addBtn = $('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (addBtn.dataset.defaultText || 'Add to Cart')
          : 'Sold Out';
      }
    }
  }

  /* ============================================================
     QUANTITY BUTTONS
  ============================================================ */
  on(document, 'click', (e) => {
    const btn = e.target.closest('.qty-btn:not([data-key])');
    if (!btn) return;
    const input = btn.closest('.product-info__quantity')?.querySelector('.qty-input');
    if (!input) return;
    const val = parseInt(input.value) || 1;
    if (btn.dataset.dir === 'up') input.value = val + 1;
    else if (val > 1) input.value = val - 1;
  });

  /* ============================================================
     RARE PARTS — NOTIFY ME
  ============================================================ */
  $$('.rare-item__notify-btn').forEach(btn => {
    on(btn, 'click', () => {
      btn.textContent = 'Notified ✓';
      btn.style.background = 'var(--color-od-green)';
      btn.style.borderColor = 'var(--color-od-green)';
      btn.style.color = 'white';
      btn.disabled = true;
    });
  });

  /* ============================================================
     ANNOUNCEMENT BAR — DISMISS
  ============================================================ */
  const announceDismiss = $('#announcement-dismiss');
  on(announceDismiss, 'click', () => {
    const bar = announceDismiss.closest('.announcement-bar');
    if (bar) bar.style.display = 'none';
    sessionStorage.setItem('announcement-dismissed', '1');
  });

  if (sessionStorage.getItem('announcement-dismissed') === '1') {
    const bar = $('.announcement-bar');
    if (bar) bar.style.display = 'none';
  }

  /* ============================================================
     MONEY FORMATTER
  ============================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ============================================================
     INIT CART COUNT ON LOAD
  ============================================================ */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

  /* ============================================================
     COLLECTION FILTER TOGGLE (MOBILE)
  ============================================================ */
  const filterToggle = $('#filter-toggle');
  const filterSidebar = $('.filter-sidebar');
  on(filterToggle, 'click', () => {
    if (filterSidebar) filterSidebar.classList.toggle('is-open');
  });

  /* ============================================================
     SMOOTH SCROLL
  ============================================================ */
  $$('a[href^="#"]').forEach(a => {
    on(a, 'click', (e) => {
      const id = a.getAttribute('href');
      const target = $(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ============================================================
     CART DRAWER ITEM STYLES (injected)
  ============================================================ */
  const drawerStyles = document.createElement('style');
  drawerStyles.textContent = `
    .cart-drawer-item { padding: 14px 0; border-bottom: 1px solid var(--color-border); }
    .cart-drawer-item__inner { display: grid; grid-template-columns: 70px 1fr; gap: 14px; }
    .cart-drawer-item__img { width: 70px; height: 70px; object-fit: cover; border-radius: 0; background: var(--color-surface-2); }
    .cart-drawer-item__title { font-family: var(--font-body); font-size: 13px; font-weight: 600; color: var(--color-text); margin-bottom: 4px; display: block; }
    .cart-drawer-item__variant { font-size: 12px; color: var(--color-text-muted); margin-bottom: 10px; }
    .cart-drawer-item__footer { display: flex; align-items: center; justify-content: space-between; }
    .cart-drawer-item__qty { display: flex; align-items: center; gap: 8px; }
    .cart-drawer-item__qty .qty-btn { font-size: 1rem; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; border: 1px solid var(--color-border); border-radius: 0; color: var(--color-text); background: var(--color-surface-2); }
    .cart-drawer-item__qty span { font-size: 14px; min-width: 20px; text-align: center; }
    .cart-drawer-item__price { font-family: var(--font-body); font-size: 14px; font-weight: 700; color: var(--color-text); }
  `;
  document.head.appendChild(drawerStyles);

})();
